import { useFeatureToggle } from '../../utils/hooks/useFeatureToggle';

/**
 * AiScannerContainer Component
 *
 * Renders the AI Scanner UI on the scan page when the AI Scanner feature
 * toggle (`aiScannerPopsicleEnabled`) is enabled. While the feature flags are
 * still loading, or when the feature is disabled, nothing is rendered.
 *
 * @returns {JSX.Element|null} The AI Scanner element or null when not enabled
 */
export const AiScannerContainer = () => {
  const { isLoading, isFeatureEnabled } = useFeatureToggle('aiScannerPopsicleEnabled');

  if (isLoading === undefined || isLoading === true) {
    return null;
  }

  if (!isFeatureEnabled) {
    return null;
  }

  return (
    <div className="ai-scanner-container">
      <span className="indicator-letter">S</span>
    </div>
  );
};

export default AiScannerContainer;
